import React from "react";

export default function NewsAccountDeletionInfo() {
	return (
		<div className='max-w-3xl mx-auto px-4 py-8 text-gray-800 font-sans'>
			<h1 className='text-2xl font-bold mb-4'>Delete Your Bites Account</h1>
			<p className='mb-1'>
				<strong>App name:</strong> Bites - News in 50 words
			</p>
			<p className='mb-4'>
				<strong>Developer Name:</strong> Fine Labs Developer
			</p>

			<p className='mb-6'>
				If you no longer wish to use our services and would like to delete your
				Bites account, you can do so at any time. Deleting your account will
				permanently remove your personal data from our systems and cannot be
				undone.
			</p>

			<h2 className='text-xl font-semibold mb-2'>
				Steps to Request Account Deletion
			</h2>
			<ol className='list-decimal list-inside mb-6 space-y-1'>
				<li>Log in to your Bites app using your registered account.</li>
				<li>
					Go to the <strong>Profile</strong> section.
				</li>
				<li>
					Select the <strong>Edit profile</strong> icon.
				</li>
				<li>
					Tap on the <strong>Delete Account</strong> button.
				</li>
			</ol>

			<h2 className='text-xl font-semibold mb-2'>
				What Happens After Deletion?
			</h2>
			<ul className='list-disc list-inside mb-6'>
				<li>Your account and associated data will be permanently deleted.</li>
			</ul>

			<h2 className='text-xl font-semibold mb-2'>Contact Us</h2>
			<p>
				If you have any questions about the process, feel free to contact our
				support team:
				<br />
				<a
					href='mailto:support@finelabs.in'
					className='text-blue-600 hover:underline'>
					support@finelabs.in
				</a>
			</p>
		</div>
	);
}
